<template>
  <div>
    <p class="title" v-if="showTitle">{{ title }}</p>
    <p class="sub-title" v-if="showSubTitle">{{ subTitle }}</p>

    <template v-if="showCollaborators">
      <!-- Contenido a paginar -->
      <div
        v-for="(item, index) in paginatedItems"
        :key="index"
        class="mb-3 my-item-retraction"
      >
        <!-- Información respuesta del permiso -->
        <b-row class="my-row">
          <b-col>
            <b-row class="pb-4">
              <b-col class="box">
                <strong>Colaborador</strong>:
                {{ getModifiedEmployeeName(item) }}
                <br />
                <strong>Gestión del permiso</strong>:
                {{ formatStateManagement(item) }}
                <br />
                <strong>fecha</strong>:
                {{
                  $moment(item.updated_at).format(
                    "DD [de] MMMM [de] YYYY [-] h:m A"
                  )
                }}
                <br />
                <strong
                  >Fechas de permiso rechazados:
                  <span
                    v-for="(day, idx_day) in getDaysReject(item)"
                    :key="idx_day"
                  >
                    {{ day.day | moment("DD")
                    }}{{
                      getDaysReject(item).length - 1 > idx_day ? "," : null
                    }}
                  </span>
                  <template v-if="getLastDay(getDaysReject(item))">{{
                    getLastDay(getDaysReject(item))
                      | moment("[de] MMMM [de] YYYY")
                  }}</template>
                </strong>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <p class="sub-title pt-4">Información adicional para retractarse</p>

        <!-- Informacion adicional -->
        <b-row class="my-row">
          <b-col cols="12">
            <b-row class="pb-4">
              <p>
                Selecciona los días de retractación para el colaborador
                {{ item.core_employee?.name }}
              </p>
              <b-col class="box pb-4" cols="12">
                <b-form-radio-group>
                  <label
                    class="switch-container"
                    v-for="(day, idx_btn) in getDaysReject(item)"
                    :key="'btn'.concat(idx_btn)"
                  >
                    <input
                      type="checkbox"
                      v-model="selectedCollaborator"
                      :id="day.id"
                      :value="{ id: item.id, day: day.id, has_ticket: item.has_ticket }"
                    />
                    <div class="checkbox-slider">
                      <span class="on">{{ day.day | moment("DD") }}</span>
                      <span class="off">{{ day.day | moment("DD") }}</span>
                    </div>
                  </label>
                  <template v-if="getLastDay(getDaysReject(item))">
                    <span class="switch-container-span">
                      {{
                        getLastDay(getDaysReject(item))
                          | moment("MMMM [de] YYYY")
                      }}
                    </span>
                  </template>
                </b-form-radio-group>

                <button
                  @click.prevent="approvedAll(item)"
                  style="color: #000000; border: 1px solid #000000"
                >
                  Todos los días
                </button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div v-if="isTicket">
          <p v-if="totalTickets === counter && item?.id !== itemIdSelected">
            No hay tiquetes disponibles
          </p>
          <label :for="`has_ticket-${item.id}`" v-else>
            <input
              :id="`has_ticket-${item.id}`"
              class="mycheck"
              type="checkbox"
              v-model="item.has_ticket"
              @change="changeTicket(item)"
            />
            Habilitar tiquetes aereos
          </label>
        </div>
      </div>
      <!-- text area del motivo -->
      <template v-if="showMotive">
        <p class="sub-title pt-4">Motivo de retractación</p>

        <b-row class="my-row">
          <b-form-textarea
            id="textarea-no-resize"
            placeholder="Motivo de retractación"
            rows="5"
            no-resize
            v-model.trim="motive"
            :state="validationMotive"
          ></b-form-textarea>
        </b-row>
      </template>
      <!-- Paginacion -->
      <template v-if="showPagination">
        <b-pagination
          class="justify-content-center pt-3"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          first-number
          hide-goto-end-buttons
          aria-controls="my-item-retraction"
        />
      </template>
    </template>

    <template v-else>
      <div class="box">
        <p class="box-body">
          <span class="box-body-bold">Fecha y hora:</span>
          {{ $moment(createdAt).format("DD [de] MMMM [de] YYYY [-] h:m A") }}
          <br />
          <span class="box-body-bold">Solicitante:</span>
          {{ capitalizeText(name) }}
        </p>
      </div>
    </template>
  </div>
</template>
<script>
import ApiPermisos from "@/services/apiPermisos";
import { getLicense } from "@/services/modules/permisos-sindicales/v2/licenses/service";
import { mapState } from "vuex";
export default {
  name: "Traceability",
  props: {
    createdAt: {
      type: String,
      required: false,
      default: () => "",
    },
    name: {
      type: String,
      required: false,
      default: () => "",
    },
    containTitle: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    title: {
      type: String,
      required: false,
      default: () => "",
    },
    subTitle: {
      type: String,
      required: false,
      default: () => "",
    },
    collaborators: {
      type: Array,
      required: false,
      default: () => [],
    },
    dataAvailableTickets: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    selectedCollaborator: [],
    currentPage: 1,
    motive: "",
    isTicket: false,
    totalTickets: 0,
    counter: 0,
    itemIdSelected: null,
  }),
  computed: {
    ...mapState("modRequest", ["request", "loading"]),
    showTitle() {
      return !!this.title.length;
    },
    showSubTitle() {
      return !!this.subTitle.length;
    },
    showCollaborators() {
      return !!this.collaborators.length;
    },
    formatStateManagement() {
      return ({ status, core_employee = {}, is_automatic_approval }) => {
        const employee = {
          name: core_employee.name || "",
          role: core_employee.core_role ? core_employee.core_role.name : "",
        };
        const list = {
          approved: is_automatic_approval
            ? "Aprobación automatica"
            : `Aprobado por ${employee.name} (${employee.role})`,
          pending: "Pendiente",
          rejected: `Rechazado por ${employee.name} (${employee.role})`,
          retraction: "Retracción",
        };
        return list[status] ? list[status] : "<Sin Estado>";
      };
    },
    // ## NOMBRE DEL EMPLEADO QUE HACE LA MODIFICACION
    getModifiedEmployeeName() {
      return ({ core_employee = {} }) => {
        return core_employee.name || "";
      };
    },
    getDaysReject() {
      return ({ days }) => {
        const filter = (array = Array, state = "rejected") =>
          array.filter(({ status }) => status === state);
        const orderById = (array = Array) => array.sort((a, b) => a.id - b.id);
        return orderById(filter(days));
      };
    },
    getLastDay() {
      return (array) => {
        if (array.length === 0) return null;
        return array.slice(-1)[0].day || null;
      };
    },
    showPagination() {
      return this.totalItems > 1;
    },
    perPage() {
      return 1;
    },
    totalItems() {
      return this.collaborators.length;
    },
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      return this.startIndex + this.perPage;
    },
    paginatedItems() {
      return this.collaborators.slice(this.startIndex, this.endIndex);
    },
    showMotive() {
      return this.totalItems === this.currentPage;
    },
    validationMotive() {
      return this.motive.length >= 5;
    },
    canRetract() {
      return !!(
        this.selectedCollaborator.length !== 0 && this.validationMotive
      );
    },
  },
  watch: {
    canRetract(newValue, oldValue) {
      if (newValue !== oldValue)
        this.$emit("change:canRetract", { can: this.canRetract });
    },
    selectedCollaborator: {
      handler() {
        this.send();
      },
      deep: true,
    },
    motive() {
      if (this.validationMotive) this.send();
    },
  },
  methods: {
    approvedAll(collaborator) {
      this.getDaysReject(collaborator).forEach(({ id }) => {
        document.getElementById(id).checked = true;
        this.selectedCollaborator = [
          { id: collaborator.id, day: id, has_ticket: collaborator.has_ticket },
          ...this.selectedCollaborator,
        ];
      });
      this.clearSelected();
      this.send();
    },
    send() {
      const data = {
        license: this.selectedCollaborator,
        motive: this.capitalizeFirstLetter(this.motive),
      };
      this.$emit("change:daysRetraction", { days: data, can: this.canRetract });
    },
    clearSelected() {
      this.selectedCollaborator = [
        ...new Map(
          this.selectedCollaborator.map((item) => [item.day, item])
        ).values(),
      ];
    },
    async loadLimitedTickets() {
      const me = this;
      me.totalTickets = 0;
      try {
        const { result } = await getLicense(me.$route.params.id);
        const dataSend = {
          ...me.dataAvailableTickets,
          type: result?.license_employees[0]?.ticket?.type,
          labor_union_id: result?.laborUnion_id,
          requiredTickets: this.collaborators.length,
          society_id: result?.bp?.society_id,
        };

        // tickets
        me.isTicket = result?.tickets === 1;
        if (me.isTicket) {
          const res = await ApiPermisos.limitRequestValidation(dataSend);
          me.totalTickets = res?.result?.can_only_be_managed;
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeTicket(value) {
      const me = this;
      me.itemIdSelected = value?.id;
      if (value?.has_ticket) {
        me.counter += 1;
      } else if (me.counter > 0 && !value?.has_ticket) {
        me.counter -= 1;
      }
      if (this.selectedCollaborator.length > 0) {
        this.selectedCollaborator.forEach((item) => {
          if (item.id === value.id) {
            item.has_ticket = value.has_ticket;
          }
        })
      }
    }
  },
  mounted() {
    const me = this;
    console.log(me.collaborators)
    me.itemIdSelected = me.collaborators[0]?.id;
    me.loadLimitedTickets();
  },
};
</script>
<style lang="scss" src="./styles.scss" />
